import React, { useState, useEffect, useCallback } from 'react';
import Grid from '@mui/material/Grid';
import { ListItemText, Box, ButtonGroup, Stack, Paper, Typography } from '@mui/material';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Crop169Icon from '@mui/icons-material/Crop169';
import TodayIcon from '@mui/icons-material/Today';
import UploadIcon from '@mui/icons-material/Upload';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import update from 'immutability-helper'
import { useDrag } from 'react-dnd'
import HomeIcon from '@mui/icons-material/Home';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useDrop } from 'react-dnd'
import CardDrag from '../../../util/CardDrag';
import PropertiePanel from '../../../common/PropertiePanel';
import Service from '../../../../util/Service';
import { Check, List } from '@mui/icons-material';

const style = {
    width:'95%',
}
const styleBox = {
    border: '1px solid gray',
    backgroundColor: 'white',
    height: 35,
    cursor: 'move',
}
var currentIndex = 0;

// export default function UserTaskFormConstruction(props) {
const UserTaskFormConstruction = React.forwardRef((props, ref) => {
    const { setCards, cards, item, processo, onClose, } = props;
    const [propsId, setPropsId] = useState(-1);

    const moveCard = useCallback((dragIndex, hoverIndex) => {
        setCards((prevCards) =>
            update(prevCards, {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, prevCards[dragIndex]],
                ],
            }),
        )
    }, [])

    const removeCard = useCallback((index) => {
        setCards((prevCards) => prevCards.filter((_, i) => i !== index));
    }, []);

    const renderCard = useCallback((card, index) => {
        return (
            <CardDrag
                key={card.id}
                index={index}
                id={card.id}
                type={card.type}
                properties={card.properties}
                moveCard={moveCard}
                updateIndex={updateIndex}
                onClick={handleClickCommponent}
                onDelete={removeCard}
            />
        )
    }, [moveCard, removeCard])
    //-----------------------

    const BoxDrag = function Box({ id, index, content, name, onDropEnd }) {
        const [{ isDragging }, drag] = useDrag(() => ({
            type: 'card',
            item: { id, index, name },
            end: (item, monitor) => {
                const dropResult = monitor.getDropResult()
                if (item) {
                    if (onDropEnd) onDropEnd(item, index);
                }
            },
            collect: (monitor) => ({
                isDragging: monitor.isDragging(),
                handlerId: monitor.getHandlerId(),
            }),
        }))
        const opacity = isDragging ? 0.4 : 1
        return (
            <div ref={drag}
                style={{ ...styleBox, opacity }}
                data-testid={`box`}>
                {content}
            </div>
        )
    }
    const FormContent = () => {
        const [{ canDrop, isOver }, drop] = useDrop(() => ({
            accept: 'box',
            drop: () => ({ name: 'FormContent' }),
            collect: (monitor) => ({
                isOver: monitor.isOver(),
                canDrop: monitor.canDrop(),
            }),
        }))
        const isActive = canDrop && isOver
        let backgroundColor = '#FFFFF0'
        if (isActive) {
            backgroundColor = '#808080'
        } else if (canDrop) {
            backgroundColor = 'cyan'
        }
        return (
            <Paper 
                variant="outlined" 
                square 
                sx={{ 
                    minHeight: 400, 
                    maxHeight: 500,
                    overflowY: 'auto', // Scroll apenas na vertical
                    overflowX: 'hidden' // Remove o scroll lateral
                }} 
                ref={drop} 
                data-testid="FormContent"
            >
                <div style={style}>
                    {cards && cards.map((card, i) => renderCard(card, i))}
                </div> 
            </Paper>

        
        )
    }
    
    function handleClickCommponent(type, index) {
        console.log(index);
        setPropsId(index);
    }

    function onDropEnd(item, index) {
        // console.log("lalalala", item, index, currentIndex);
        var arr = [...cards];
        
        let bool = false;        
        if (cards.length === 0) {
            bool = true;
            arr.push({
                id: 1,
                type: item.name
            })
        }
        if (!bool) {
            arr.push({
                id: arr.length + 1,
                type: item.name
            })
        }
        setCards(arr);
    }

    const updateIndex = (index) => {
        currentIndex = index;
    }

    const saveProperties = (item) => {
        let arr = [...cards];
        arr[propsId].properties = item;
        setCards(arr);
    }

    React.useImperativeHandle(ref, ()=> ({
        childMethod() {
            handleSalva();
          }
    }))
    const handleSalva = () => {
        const dado = {
            idTask: item.id,
            idProcesso: processo.id,
            taskType: item.type,
            form: cards
        }

        Service.POST('/api/bpmn/salvarTaskDoProcesso', dado).then(resp => {
            // setWait(false);
            // onClose();
        }).catch(error => {
            console.error(error)
            // setWait(false);
            // setMensagem(error ? error : 'Oops! Something went wrong. Please try again!');
        })
    }
    return (
        <div style={{width:'100%'}}>
            <Grid container spacing={2} style={{ marginTop: 5, padding: '16px' }}>
                <DndProvider backend={HTML5Backend}>
                    <Grid size={3}>
                        <Paper elevation={3} style={{ padding: '16px', height: '100%' }}>
                            <Typography variant="h6" style={{ marginBottom: '16px', marginLeft: '16px' }}>
                                Componentes 
                            </Typography>
                            <Stack style={{ overflow: 'hidden', clear: 'both' }}>
                            <BoxDrag
                                    index={-1} id={-1}
                                    onDropEnd={onDropEnd} 
                                    name="breadcrumbs"
                                    content={
                                        <Stack direction="row" spacing={1} style={{ marginTop: 6 }}>
                                            <HomeIcon />
                                            <ListItemText primary="breadcrumbs" />
                                        </Stack>
                                    } />
                                <BoxDrag
                                    index={-1} id={-1}
                                    onDropEnd={onDropEnd} 
                                    name="camposUserLogado"
                                    content={
                                        <Stack direction="row" spacing={1} style={{ marginTop: 6 }}>
                                            <AccountCircleIcon />
                                            <ListItemText primary="Campo User" />
                                        </Stack>
                                    } />
                                <BoxDrag
                                    index={-1} id={-1}
                                    onDropEnd={onDropEnd} 
                                    name="textField"
                                    content={
                                        <Stack direction="row" spacing={1} style={{ marginTop: 6 }}>
                                            <TextFieldsIcon />
                                            <ListItemText primary="Campo texto" />
                                        </Stack>
                                    } />
                                <BoxDrag
                                    index={-1} id={-1}
                                    onDropEnd={onDropEnd} 
                                    name="selectField"
                                    content={
                                        <Stack direction="row" spacing={1} style={{ marginTop: 6 }}>
                                            <List />
                                            <ListItemText primary="Campo Seleção" />
                                        </Stack>
                                    } />
                                <BoxDrag
                                    index={-1} id={-1}
                                    onDropEnd={onDropEnd} 
                                    name="textFieldMoeda"
                                    content={
                                        <Stack direction="row" spacing={1} style={{ marginTop: 6 }}>
                                            <AttachMoneyIcon />
                                            <ListItemText primary="Monetário" />
                                        </Stack>
                                    } />
                                <BoxDrag
                                    index={-1} id={-1}
                                    onDropEnd={onDropEnd} 
                                    name="dataField"
                                    content={
                                        <Stack direction="row" spacing={1} style={{ marginTop: 6 }}>
                                            <TodayIcon />
                                            <ListItemText primary="Campo data" />
                                        </Stack>
                                    } />
                                <BoxDrag
                                    index={-1} id={-1}
                                    onDropEnd={onDropEnd} 
                                    name="checkBox"
                                    content={
                                        <Stack direction="row" spacing={1} style={{ marginTop: 6 }}>
                                            <Check />
                                            <ListItemText primary="CheckBox" />
                                        </Stack>
                                    } />
                                <BoxDrag
                                    index={-1} id={-1}
                                    onDropEnd={onDropEnd} 
                                    name="radio"
                                    content={
                                        <Stack direction="row" spacing={1} style={{ marginTop: 6 }}>
                                            <RadioButtonCheckedIcon />
                                            <ListItemText primary="Radio" />
                                        </Stack>
                                    } />                                
                                <BoxDrag
                                    index={-1} id={-1}
                                    onDropEnd={onDropEnd} 
                                    name="radioGroup"
                                    content={
                                        <Stack direction="row" spacing={1} style={{ marginTop: 6 }}>
                                            <RadioButtonCheckedIcon />
                                            <ListItemText primary="Radio Group" />
                                        </Stack>
                                    } />
                                <BoxDrag
                                    index={-1} id={-1}
                                    onDropEnd={onDropEnd} 
                                    name="textArea"
                                    content={
                                        <Stack direction="row" spacing={1} style={{ marginTop: 6 }}>
                                            <Crop169Icon />
                                            <ListItemText primary="Area de Texto" />
                                        </Stack>
                                    } />
                                <BoxDrag
                                    index={-1} id={-1}
                                    onDropEnd={onDropEnd} 
                                    name="uploadUnico"
                                    content={
                                        <Stack direction="row" spacing={1} style={{ marginTop: 6 }}>
                                            <UploadIcon />
                                            <ListItemText primary="Upload Unico" />
                                        </Stack>
                                    } />
                                <BoxDrag
                                    index={-1} id={-1}
                                    onDropEnd={onDropEnd} 
                                    name="upload"
                                    content={
                                        <Stack direction="row" spacing={1} style={{ marginTop: 6 }}>
                                            <UploadIcon />
                                            <ListItemText primary="Upload" />
                                        </Stack>
                                    } />
                            </Stack>
                        </Paper>
                    </Grid>

                    <Grid size={6}>
                        <Paper elevation={3} style={{ padding: '16px', height: '100%' }}>
                            <Typography variant="h6" style={{ marginBottom: '16px', marginLeft: '16px' }}>
                                Campos
                            </Typography>
                            <Stack>
                                <div style={{ overflow: 'hidden', clear: 'both' }}>
                                    <FormContent />
                                </div>
                                <Box
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        marginTop: '16px',
                                    }}
                                >
                                    {/* <ButtonGroup variant="outlined" aria-label="text button group">
                                        <Button color='inherit' onClick={handleSalva}>Salvar</Button>
                                        <Button color='inherit'>Sair</Button>
                                    </ButtonGroup> */}
                                </Box>
                            </Stack>
                        </Paper>
                    </Grid>

                    <Grid size={3}>
                        <Paper elevation={6} style={{ padding: '16px', height: '100%' }}>
                            <Typography variant="h6" style={{ marginBottom: '16px', marginLeft: '16px' }}>
                                Propriedades
                            </Typography>
                            <PropertiePanel propsId={propsId} cards={cards} saveProperties={saveProperties} />
                        </Paper>
                    </Grid>
                </DndProvider>
            </Grid>
        </div >
    );
})

export default UserTaskFormConstruction;